import { Actions } from 'interfaces/store';
import { isEmpty } from 'lodash-es';
import { parse as parseQuery, ParsedUrlQuery } from 'querystring';
import { parse, Url } from 'url';

export const getQueryParameter = (urlString: string, paramName: string): string => {
  const url = parse(urlString);
  const queryParamsString: string = url.query || '';
  const queryParams: ParsedUrlQuery = parseQuery(queryParamsString);
  const value: string | string[] = (queryParams && queryParams[paramName]) || [];
  return value ? value.toString() : '';
};

export const getPathVariableFromEnd = (urlString: string, countFromEnd: number): string => {
  const url: Url = parse(urlString);
  const pathVariables: string[] | undefined = url.pathname?.split('/');

  return pathVariables ? pathVariables[pathVariables.length - countFromEnd] : '';
};

export const getApiDomain = (voucherType: string): string => {
  return process.env.REACT_APP_API_DOMAIN?.replace('{voucherType}', voucherType) || '';
};

export const getSearchApiDomain = (): string => {
  return `${process.env.REACT_APP_API_DOMAIN}travel/address` || '';
};

export const getAbnSearchApiDomain = (): string =>
  getEnvValue(process.env.REACT_APP_API_ABN_DOMAIN);

export const getAppBaseUrl = () => {
  const baseUrl = getAppDomainUrl();
  return baseUrl + '/services/disability-worker-registration';
};

export const getAppDomainUrl = () => {
  const baseUrl = process.env.REACT_APP_DOMAIN || '';
  return baseUrl;
};

export const getWestpacUrl = (): string => getEnvValue(process.env.REACT_APP_WESTPAC_URL, '');

export const getWestpacKey = (): string => getEnvValue(process.env.REACT_APP_WESTPAC_KEY, '');

export const doUglyStateFix = (stepId: string, actions: Actions): void => {
  //   actions.updateInitialStep(stepId);
  const homeUrl = getAppBaseUrl() + '/transaction';
  document.location.href = homeUrl;
};

const getEnvValue = (value?: string, defaultValue?: string): string => {
  return isEmpty(value) ? defaultValue || '' : value || '';
};

export const getWestpacBusinessCode = (): string =>
  process.env.REACT_APP_WESTPAC_BUSINESS_CODE || '';
